"use client";
const e = {
  base: "relative inline-flex w-fit",
  wide: "w-full",
  badge: [
    "flex",
    "z-10",
    "flex-wrap",
    "absolute",
    "box-border",
    "rounded-full",
    "whitespace-nowrap",
    "place-content-center",
    "origin-center",
    "items-center",
    "text-inherit",
    "select-none",
    "font-regular",
    "scale-100",
    "opacity-100",
    "subpixel-antialiased",
    "pointer-events-none",
    "duration-200",
    "data-[invisible=true]:scale-0",
    "data-[invisible=true]:opacity-0"
  ],
  size: {
    sm: "px-1 text-xs h-4 min-w-4 min-h-4",
    md: "px-1.5 text-sm h-5 min-w-5 min-h-5",
    lg: "px-2 text-sm h-6 min-w-6 min-h-6"
  },
  placement: {
    "top-right": [
      "-translate-y-1/2 top-[5%]",
      "data-[shape=rectangle]:right-0",
      "data-[shape=circle]:translate-x-1/2 data-[shape=circle]:right-[5%]"
    ],
    "top-left": [
      "-translate-y-1/2 top-[5%]",
      "data-[shape=rectangle]:left-0",
      "data-[shape=circle]:-translate-x-1/2  data-[shape=circle]:left-[5%]"
    ],
    "bottom-right": [
      "translate-y-1/2 bottom-[5%]",
      "data-[shape=rectangle]:right-0",
      "data-[shape=circle]:translate-x-1/2 data-[shape=circle]:right-[5%]"
    ],
    "bottom-left": [
      "translate-y-1/2 bottom-[5%]",
      "data-[shape=rectangle]:left-0",
      "data-[shape=circle]:-translate-x-1/2 data-[shape=circle]:left-[5%]"
    ]
  },
  isDot: {
    sm: "w-3 h-3 min-w-3 min-h-3 p-0",
    md: "w-3.5 h-3.5 min-w-3.5 min-h-3.5 p-0",
    lg: "w-4 h-4 min-w-4 min-h-4 p-0"
  },
  isOneChar: "px-0",
  isPing: "before:absolute before:inset-0 before:rounded-full before:bg-[inherit] before:opacity-50 before:-z-1 before:animate-ping",
  showOutline: "inset-ring-2 inset-ring-body",
  onClick: "pointer-events-auto cursor-pointer"
};
export {
  e as stylesBadge
};
